import {Component, inject} from '@angular/core';
import { ProcessingService } from "./processing-service";

@Component({
  selector: 'app-processing-overlay',
  imports: [],
  templateUrl: './processing-overlay.html',
  styleUrl: './processing-overlay.scss',
})
export class ProcessingOverlay {
  protected readonly processingService = inject(ProcessingService);
}
